// ============================================================
//  src/admin/AdminLogin.jsx
// ============================================================

import React, { useState } from "react";

// ── Credentials (change these!) ──────────────────────────────
const ADMIN_USER = "brandpartners";
const ADMIN_PASS = "studio@2024";

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    setTimeout(() => {
      if (username === ADMIN_USER && password === ADMIN_PASS) {
        sessionStorage.setItem("admin_auth", "true");
        onLogin();
      } else {
        setError("Invalid username or password.");
      }
      setLoading(false);
    }, 600);
  };

  return (
    <div style={styles.root}>
      <div style={styles.card}>

        {/* Logo */}
        <div style={styles.logo}>
          <span style={styles.logoMark}>✦</span>
          <div>
            <div style={styles.logoName}>BRAND PARTNERS</div>
            <div style={styles.logoSub}>STUDIO AND GIFTS</div>
          </div>
        </div>

        <h1 style={styles.title}>Admin Login</h1>
        <p style={styles.subtitle}>Sign in to access the portfolio manager</p>

        <form onSubmit={handleSubmit} style={styles.form}>

          {/* Username */}
          <div style={styles.field}>
            <label style={styles.label}>USERNAME</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </div>

          {/* Password */}
          <div style={styles.field}>
            <label style={styles.label}>PASSWORD</label>
            <div style={{ position: "relative" }}>
              <input
                style={{ ...styles.input, paddingRight: 44 }}
                type={showPass ? "text" : "password"}
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                style={styles.eyeBtn}
              >
                {showPass ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div style={styles.error}>✗ {error}</div>
          )}

          {/* Submit */}
          <button
            type="submit"
            style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
            disabled={loading}
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>

        </form>

      </div>
    </div>
  );
};

const styles = {
  root: {
    minHeight: "100vh",
    background: "#080808",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  card: {
    background: "#0f0f0f",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 6,
    padding: "48px 44px",
    width: "100%",
    maxWidth: 420,
    boxShadow: "0 30px 80px rgba(0,0,0,0.6)",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginBottom: 36,
  },
  logoMark: {
    fontSize: "1.6rem",
    color: "#c9a96e",
    lineHeight: 1,
  },
  logoName: {
    fontFamily: "'DM Serif Display', Georgia, serif",
    fontSize: "0.95rem",
    color: "rgba(255,255,255,0.88)",
    letterSpacing: "0.08em",
  },
  logoSub: {
    fontSize: "0.48rem",
    color: "rgba(255,255,255,0.28)",
    letterSpacing: "0.22em",
    textTransform: "uppercase",
    marginTop: 2,
  },
  title: {
    fontFamily: "'DM Serif Display', Georgia, serif",
    fontSize: "1.8rem",
    fontWeight: 400,
    color: "rgba(255,255,255,0.88)",
    margin: "0 0 8px",
    letterSpacing: "-0.02em",
  },
  subtitle: {
    fontSize: "0.76rem",
    color: "rgba(255,255,255,0.35)",
    margin: "0 0 32px",
    lineHeight: 1.6,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: 7,
  },
  label: {
    fontSize: "0.58rem",
    letterSpacing: "0.18em",
    color: "rgba(255,255,255,0.35)",
    textTransform: "uppercase",
  },
  input: {
    background: "#161616",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 3,
    padding: "12px 14px",
    fontSize: "0.85rem",
    color: "rgba(255,255,255,0.88)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    fontFamily: "'Cormorant Garamond', serif",
    transition: "border-color 0.2s",
  },
  eyeBtn: {
    position: "absolute",
    right: 12,
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    color: "rgba(255,255,255,0.35)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    padding: 0,
  },
  error: {
    background: "#2a1010",
    border: "1px solid rgba(224,91,91,0.25)",
    color: "#e05b5b",
    padding: "10px 14px",
    borderRadius: 3,
    fontSize: "0.74rem",
  },
  btn: {
    background: "#c9a96e",
    border: "none",
    borderRadius: 3,
    padding: "13px",
    fontSize: "0.72rem",
    fontWeight: 600,
    letterSpacing: "0.1em",
    color: "#080808",
    cursor: "pointer",
    marginTop: 4,
    transition: "background 0.2s",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
};

export default AdminLogin;